import {
  create_bed,
  update_bed,
  delete_bed,
  recover_bed,
  query_bed_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-bed-config';

import { reactive } from 'vue';
import { get_is_active, getDateTime } from '@/utils/function';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '床位编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写床位编号',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '隶属门店',
        disabled: false,
        placeholder: '请选择隶属门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      name: null,
      shop_id: null,
    }),
  };
  const search_options = {
    is_active: [
      { value: None, name: '全部' },
      { value: True, name: '可用' },
      { value: False, name: '作废' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '床位编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写床位编号',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '隶属门店',
        disabled: !!current_shop,
        placeholder: '请选择隶属门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
    ],
    rules: {
      name: [{ required: true, message: '请填输入床位编号' }],
      shop_id: [{ required: true, message: '请填输入隶属门店' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      name: null,
      shop_id: current_shop?.id,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '床位编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写床位编号',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '隶属门店',
        disabled: true,
        placeholder: '请选择隶属门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      name: null,
      shop_id: null,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '床位管理',
    addModalTitle: '新建床位',
    updateTitle: '修改床位',
    is_create: true, // 是否有【新建】按钮
    is_update: true, // 是否有【修改】按钮
    is_remove: true, // 是否有【删除】按钮
    is_recover: true, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      bed_id: 'id',
    },
    delete: {
      bed_id: 'id',
    },
    recover: {
      bed_id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      bed_id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '床位编号',
      dataIndex: 'name',
      checked: true,
    },
    {
      title: '门店名称',
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      checked: true,
      content: (record: any, text: any) => {
        let content = '';
        switch (text) {
          case 0:
            content = '空闲';
            break;
          case 1:
            content = '使用中';
            break;
          case 2:
            content = '不可用';
            break;
          default:
            content = '';
            break;
        }
        return content;
      },
      filterMultiple: true,
      filters: [
        { text: '全部', value: '' },
        { text: '空闲', value: '0' },
        { text: '使用中', value: '1' },
        { text: '不可用', value: '2' },
      ],
    },
    {
      title: '创建日期',
      dataIndex: 'create_time',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '是否可用',
      dataIndex: 'is_active',
      checked: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '禁用',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: true },
        { text: '作废', value: false },
      ],
      content: (record: any, text: any) => {
        return get_is_active(text);
      },
    },

    {
      title: '操作',
      width: 250,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push(
    { type: 'custom', slotName: 'status', field_0: '空闲', field_1: '使用中', field_2: '不可用' },
    { type: 'custom', field_true: '可用', field_false: '作废' },
  );

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_bed_list,
    addData: create_bed,
    updateData: update_bed,
    removeData: delete_bed,
    recoverData: recover_bed,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
